import "./Page404.css"

const Page404 = () => {
    return (
        <div className="page404">
            <img className="logoError" src="/img/icon-naruto.svg" alt="logo"/>
           <div>
                <h2>Oops! Esta página no existe</h2>
           </div>
        </div>
    )
}

export { Page404 }